class BaseDecorator {
  constructor(data) {
    Object.assign(this, {
      uuid: data.id || null,
      ...this.transformData(data),
    });
  }

  transformData(data) {
    return data;
  }
}

export const translates = (attrs) => (Klass) => {
  return class TranslatableObject extends Klass {
    static get name() {
      return `Translatable${Klass.name}`;
    }

    constructor(data = {}) {
      super({
        ...data,
        // Skip empty translations
        translations: (data.translations || []).filter(
          (t) => !!Object.keys(t).find((k) => k !== "id" && k !== "locale" && t[k])
        ),
      });

      attrs.forEach((attr) => {
        if (!(attr in this)) {
          Object.defineProperty(this, attr, {
            get: () => this.readTranslatedAttribute(attr),
          });
        }
      });
    }

    getTranslation(locale) {
      return (
        this.translations.find((t) => t.locale === locale) || {
          locale,
          ...Object.assign(...attrs.map((attr) => ({ [attr]: null }))),
        }
      );
    }

    readTranslatedAttribute(attr, locale = I18n.locale, withFallbacks = true) {
      const fallbacks = withFallbacks ? this.getFallbackLocales(locale, attr) : [locale];
      const availableLocale = fallbacks.find((locale) => {
        const t = this.getTranslation(locale);
        return t[attr] !== undefined && t[attr] !== null;
      });
      return this.getTranslation(availableLocale)[attr];
    }

    get available_locales() {
      return this.translations.map((t) => t.locale);
    }

    get default_locale() {
      if (this.available_locales.indexOf(I18n.locale) !== -1) {
        return I18n.locale;
      } else if (this.available_locales.indexOf("en") !== -1) {
        return "en";
      } else {
        return this.translations[0] ? this.translations[0].locale : I18n.locale;
      }
    }

    getFallbackLocales(locale, attr) {
      if (this.available_locales.indexOf(locale) !== -1) {
        return [locale];
      } else {
        return [this.default_locale];
      }
    }

    get translation() {
      return this.getTranslation(this.default_locale);
    }
  };
};
BaseDecorator.translates = translates;

export default BaseDecorator;



// WEBPACK FOOTER //
// ./src/lib/decorators/BaseDecorator.js